import styled from "styled-components";

export const Container = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  border-radius: 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  height: 100vh;
  padding: 0 5rem 5rem 5rem;
  width: 42rem;

  .header {
    flex-shrink: 0;
    order: 1;
  }
  .content {
    order: 2;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const DamInfo = styled.div`
  background-color: rgba(255, 255, 254, 1);
  font-size: 1.8rem;
  margin-bottom: 2.6rem;
  padding-top: 6rem;
  padding-bottom: 2rem;
  width: 100%;

  p {
    margin: 0;
  }

  .dam-id {
    color: ${(props) => props.theme.colors.primaryBlue};
    font-weight: 600;
  }

  .consignee-name {
    font-weight: 800;
    margin-top: 0.5rem;
    margin-bottom: 1.2rem;
  }
`;

interface IStatusDiv {
  status?: string;
  clickable?: any;
}
export const StatusDiv = styled.div<IStatusDiv>`
  ${(props) => {
    const status = props.status.toLowerCase();
    let color, backgroundColor;
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    }
    return `
      span {
        background-color: ${backgroundColor} !important;
        color: ${color} !important;
        font-size: 1.1rem;
        font-weight: 600;
        padding: 0.6rem;
      }
      margin-bottom: 0.5rem;
      margin-top: 0.75rem;
      margin-right: 1rem;
  `;
  }}
`;

export const StatusInfo = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  font-weight: 500;
  width: 100%;
`;

export const StatusCard = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0px 5px 5px rgb(231 231 234 / 62%);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  height: 100%;
  margin-bottom: 0.8rem;
  padding: 1rem 1.5rem;
  width: 100%;

  .status-section {
    display: flex;
  }
`;
